import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core/src/translate.service';
import * as moment from 'moment/moment';
import { Modal } from 'ngx-modal/Modal';
import { TranslateKey } from '../../../common/pipes/translate-key.pipe';
import { CommonService } from '../../../shared/services/common.service';
import { CommonMessage } from '../../common/common-messages';
import { UploadJapanCountryDataConstants } from '../../constants/upload-japan-country-data.constants';
import { NotificationType } from "../../enums/notification-types.enum";
import { UploadJapanCountryData } from '../../interface/upload-japan-country-data.interface';
import { DeleteModal } from '../../models/delete-modal';
import { CustomerService } from '../../services/customer.service';


@Component({
    selector: 'app-upload-japan-country-data',
    templateUrl: '../../templates/template1/views/configuration/upload-japan-country-data.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/css/ticket.less',
        '../../templates/template1/themes/default/css/upload-japan-country-data.component.less']
})
export class UploadJapanCountryDataComponent implements OnInit {
    @Input() isFileUpload: boolean;
    operatingCountries: any[];
    month = 0;
    monthsDropDown = [];
    yearDropDown = [];
    currentPresentYear = new Date().getFullYear();
    currentPreviousMonth = new Date().getMonth();
    currentMonth = 0;
    year = 0;
    startingYear = 2016;
    isUpdate = false;
    loadJapanDataForm: FormGroup;
    loadJapanDataInfo: any;
    isDataExist: boolean;
    defaultCountryValue: string;
    disableCountry = true;
    value = UploadJapanCountryDataConstants.VALUE;
    operatingCountryCode = UploadJapanCountryDataConstants.DEFAULT_COUNTRY_CODE;
    loadSearchResult: any[];
    isSubmitted: boolean;
    disabled: boolean;
    message: string;
    totalCCValue: number;
    clearPopup: DeleteModal;
    isDesc = true;
    sortOption = '';
    @ViewChild('uploadResponseTemplate') uploadResponseTemplate: Modal;
    @ViewChild('fileSelect') fileUploader: ElementRef;
    @ViewChild('createJapanDataModal') createJapanDataPopup: Modal;

    constructor(
        private _formbuilder: FormBuilder,
        private translatePipe: TranslateService,
        private translateKey: TranslateKey,
        private _commonService: CommonService,
        private _customerservice: CustomerService,
    ) { }

    ngOnInit(): void {
        this.defaultCountryValue = UploadJapanCountryDataConstants.DEFAULT_COUNTRY_NAME;
        this.isDesc = false;
        this.loadYearDropDown();
        this.getMonthsDropDown(this.year);
        this.year = this.currentPresentYear;
        this.getJapanDataSearchDetails();
        // this.clearPopup.viewActionButtons = true;
    }

    buildForm() {
        this.loadJapanDataForm = this._formbuilder.group({
            operatingCountryId: [this.defaultCountryValue],
            processingYear: [this.year, Validators.required],
            processingMonth: [this.month, Validators.required],
            totalCC: ['', Validators.required],
        });
    }

    /**
     * @description - Loads Year DropDown
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    loadYearDropDown() {
        for (let i = this.startingYear; i <= Number(this.currentPresentYear); i++) {
            this.yearDropDown.push(i);
        }
    }

    /**
     * @description - Loads Month DropDown Based on year
     * @date 2020-10-28
     * @param {number} year
     * @memberof LoadCountryDataComponent
     */
    getMonthsDropDown(year: number) {
        this.monthsDropDown = [];
        if (year === new Date().getFullYear()) {
            for (let i = 1; i <= Number(new Date().getMonth() + 1); i++) {
                this.monthsDropDown.push(
                    this.translateKey.transform(
                        this.translatePipe.get('common.' + moment(
                            new Date(this.currentPresentYear + '/' + '0' + i.toString() + '/01'),
                            'YYYY/mm/dd'
                        ).format('MMMM'))[this.value], false),
                );
            }
        } else {
            for (let i = 1; i <= 12; i++) {
                this.monthsDropDown.push(
                    this.translateKey.transform(
                        this.translatePipe.get('common.' + moment(
                            new Date(this.currentPresentYear + '/' + '0' + i.toString() + '/01'),
                            'YYYY/mm/dd'
                        ).format('MMMM'))[this.value], false),
                );
            }
        }
    }

    /**
     * @description - Method triggered when Clicked on Search Button
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    onSearchJapanData() {
        this.getJapanDataSearchDetails();
    }

    /**
     * @description - To Search Data Based on selected values
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    getJapanDataSearchDetails() {
        window.document.getElementById('search-button').classList.add('button-active');
        setTimeout(() => {
            window.document.getElementById('search-button').classList.remove('button-active');
        }, 1000);

        this.currentPresentYear = this.year;

        if (!this.totalCCValue) {
            this.totalCCValue = 0;
        }
        if (this.month === 0) {
            this.currentMonth = 0;
        } else {
            this.currentMonth = this.month;
        }

        this._customerservice.getJapanDataSearchResult(this.operatingCountryCode,
            this.currentPresentYear, this.currentMonth, this.totalCCValue,this.isDesc,this.sortOption).subscribe((response: any) => {
                if (response) {
                    this.loadSearchResult = response;
                } else {
                    this.loadSearchResult = [];
                }
            });
    }

    /**
     * @description - Save the new data
     * @date 2020-10-28
     * @param {LoadCountryData} loadJapanCountryRequest
     * @memberof LoadCountryDataComponent
     */
    createNewJapanData(loadJapanCountryRequest: UploadJapanCountryData) {
        if (!this.totalCCValue) {
            this.totalCCValue = 0;
        }
        if (this.month) {
            this.currentMonth = this.month;
        }
        this.currentPresentYear = this.year;
        this._customerservice.createNewJapanData(loadJapanCountryRequest, this.operatingCountryCode,
            this.currentPresentYear, this.currentMonth, this.totalCCValue).subscribe((response: any) => {
                if (response && response === UploadJapanCountryDataConstants.NEW_RECORD_ADDED) {
                    this.message = UploadJapanCountryDataConstants.DATA_INSERT_SUCCESS;
                    this._commonService.createNotification('', this.message, NotificationType.SUCCESS);
                    this.clearFields();
                    this.createJapanDataPopup.close();
                } else if (response && response === UploadJapanCountryDataConstants.RECORD_ALREADY_EXISTS) {
                    this.message = UploadJapanCountryDataConstants.RECORD_ALREADY_EXISTS;
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                    this.clearFields();
                    this.createJapanDataPopup.close();
                } else {
                    this.message = UploadJapanCountryDataConstants.DATA_INSERT_FAILED;
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                }
            });
    }

    /**
     * @description - Update the exsisting Data
     * @date 2020-10-28
     * @param {LoadCountryData} loadJapanCountryRequest
     * @memberof LoadCountryDataComponent
     */
    updateJapanDataById(loadJapanCountryRequest: UploadJapanCountryData) {
        if (!this.totalCCValue) {
            this.totalCCValue = 0;
        }
        if (this.month) {
            this.currentMonth = this.month;
        }
        this._customerservice.updateJapanDataById(loadJapanCountryRequest, this.operatingCountryCode,
            this.currentPresentYear, this.currentMonth, this.totalCCValue).subscribe((response: any) => {
                if (response && response === UploadJapanCountryDataConstants.RECORD_UPDATE_SUCCESS) {
                    this.message = UploadJapanCountryDataConstants.TOTAL_CC_UPDATE_SUCCESS;
                    this._commonService.createNotification('', this.message, NotificationType.SUCCESS);
                    this.clearFields();
                    this.createJapanDataPopup.close();
                } else {
                    this.message = UploadJapanCountryDataConstants.TOTAL_CC_UPDATE_FAILURE;
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                }
            });
    }

    /**
     * @description - Get Data By Year and Month
     * @date 2020-10-28
     * @param {number} year
     * @param {number} month
     * @memberof LoadCountryDataComponent
     */
    getJapanDataInfoByMonth(year: number, month: number) {
        this.disabled = true;
        this._customerservice.getJapanDataSearchResult(this.operatingCountryCode, year, month).subscribe((response: any) => {
            if (response) {
                this.loadJapanDataInfo = response;
                this.loadJapanDataInfo.forEach(att => {
                    this.loadJapanDataForm.patchValue({
                        operatingCountryId: this.defaultCountryValue,
                        processingYear: att.year,
                        processingMonth: att.month,
                        totalCC: att.totalCC
                    });
                });
            }
        });
    }

    /**
     * @description - Triggered when clicked on Submit Button in Popup
     * @date 2020-10-28
     * @param {boolean} isValid
     * @memberof LoadCountryDataComponent
     */
    onSubmit(isValid: boolean) {
        this.isSubmitted = true;
        if (isValid) {
            this.isSubmitted = false;
            const loadJapanDataValues = this.loadJapanDataForm.getRawValue();
            const loadJapanCountryRequest = new UploadJapanCountryData();
            loadJapanCountryRequest.operatingCountryIso = UploadJapanCountryDataConstants.DEFAULT_COUNTRY_CODE;
            loadJapanCountryRequest.processingYear = loadJapanDataValues.processingYear ? loadJapanDataValues.processingYear : '';
            loadJapanCountryRequest.processingMonth = loadJapanDataValues.processingMonth ? loadJapanDataValues.processingMonth : '';
            loadJapanCountryRequest.totalCC = loadJapanDataValues.totalCC ? loadJapanDataValues.totalCC : '';
            this.isUpdate ? this.updateJapanDataById(loadJapanCountryRequest) : this.createNewJapanData(loadJapanCountryRequest);
        }
    }

    /**
     * @description - Opens the Add/Update Modal
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    openCreateJapanDataModal() {
        if (!this.isUpdate) {
            this.month = this.currentPreviousMonth;
            this.year = this.currentPresentYear;
        }
        this.buildForm();
        this.disabled = false;
        if (this.isUpdate) {
            this.isUpdate = false;
            this.isDataExist = false;
        }
        this.createJapanDataPopup.open();
        setTimeout(function () {
            const autoFocusElement = document.getElementById('autofocus-modal-element');
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
        }, 200);
    }

    /**
     * @description - Closes the Add/Update Modal
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    closePopUp() {
        this.isSubmitted = false;
        this.createJapanDataPopup.close();
        this.clearFields();
    }

    /**
     * @description - Triggered when Clicked on Edit Icon
     * @date 2020-10-28
     * @param {number} year
     * @param {number} month
     * @memberof LoadCountryDataComponent
     */
    editJapanData(year: number, month: number) {
        this.isUpdate = true;
        this.isDataExist = true;
        this.buildForm();
        this.getJapanDataInfoByMonth(year, month);
        this.createJapanDataPopup.open();
        setTimeout(function () {
            const totalCCElement = document.getElementById('totalCC-focus');
            if (totalCCElement) {
                totalCCElement.focus();
            }
        }, 200);
    }

    /**
     * @description
     * @date 2020-10-30
     * @param {string} sortOrder
     * @memberof UploadJapanCountryDataComponent
     */
    sort(sortOrder: string) {
        this.isDesc = (this.sortOption == sortOrder) ? !this.isDesc : this.isDesc;
        this.sortOption = sortOrder;
        this.getJapanDataSearchDetails();
    }

    /**
     * @description - Reset The form after Addition
     * @date 2020-10-28
     * @memberof LoadCountryDataComponent
     */
    resetForm() {
        if (this.isUpdate) {
            this.isSubmitted = false;
            this.getJapanDataInfoByMonth(this.year, this.month);
        } else {
            this.month = 0;
            this.year = this.currentPresentYear;
            this.totalCCValue = 0;
            this.loadJapanDataForm.reset();
        }
    }

    /**
     * @description - Clears the form details 
     * @date 2020-11-02
     * @memberof LoadCountryDataComponent
     */
    clearFields() {
        this.month = 0;
        this.year = this.currentPresentYear;
        this.totalCCValue = 0;
        this.getJapanDataSearchDetails();
    }

    clear() {
        this.clearPopup.toggle = true;
        this.clearPopup.message = CommonMessage.clearFormData;
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/configuration/upload-japan-country-data.component.ts